import React from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

function DatePickerComponent({startDate, dateFormat, showMonthYearPicker, showFullMonthYearPicker, action}) { 
  return (
    <>
      <DatePicker       
        selected={startDate}
        dateFormat={dateFormat}
        showMonthYearPicker = {showMonthYearPicker}
        showFullMonthYearPicker = {showFullMonthYearPicker}
        onChange={(date) => action(date)}
      />      
    </>
  );
}

export default DatePickerComponent;
